module.exports = __webpack_public_path__ + "static/media/categories-logo-monday.6494e767.svg";